import { render } from "./VideoViewerMobile.vue?vue&type=template&id=12d138fe&scoped=true&ts=true"
import script from "./VideoViewerMobile.vue?vue&type=script&lang=ts"
export * from "./VideoViewerMobile.vue?vue&type=script&lang=ts"

import "./VideoViewerMobile.vue?vue&type=style&index=0&id=12d138fe&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d138fe"]])

export default __exports__